import { DiseñoCurricularI } from "interfaces/DiseñoCurricular";
import { DocumentacionAdjuntaI } from "./documentacionAdjunta";
import { NivelI } from "interfaces/Nivel";
import { EstadoDiseñoCurricularI } from "interfaces/EstadoDiseñoCurricular";

export interface infoFetchGetDiseñoCurricularI {
  id: number | string;
  nombre: string;
  descripcion: string;
  fechaPublicacion: Date;
  estado: EstadoDiseñoCurricularI;
  documentacionAdjunta: DocumentacionAdjuntaI[];
  nivel: NivelI;
}

export interface CreateDiseñoCurricularJsonDto {
  nombre: string;
  descripcion?: string;
  fecha_publicacion: string;
  nivel_id: number | string;
  estado_id: number | string;
  documentacion_adjunta?: {
    key: string;
    nombre: string;
    nombre_real: string;
    mime_type: string;
    size: number;
  }[];
}

export interface UpdateDiseñoCurricularJsonDto extends CreateDiseñoCurricularJsonDto {
  id: number | string;
  documentacion_eliminar?: (number | string)[];
}


class DiseñoCurricular implements DiseñoCurricularI {
  id: number | string;
  nombre: string;
  descripcion: string;
  fechaPublicacion: Date;
  estado: EstadoDiseñoCurricularI;
  documentacionAdjunta: DocumentacionAdjuntaI[];
  nivel: NivelI;

  constructor(infoFetch: infoFetchGetDiseñoCurricularI) {
    this.id = infoFetch.id;
    this.nombre = infoFetch.nombre;
    this.descripcion = infoFetch.descripcion;
    this.fechaPublicacion = new Date(infoFetch.fechaPublicacion);
    this.estado = infoFetch.estado;
    this.documentacionAdjunta = infoFetch.documentacionAdjunta;
    this.nivel = infoFetch.nivel;
  }
}

export const makeDiseñoCurricular = (
  infoFetch: infoFetchGetDiseñoCurricularI,
) => {
  return new DiseñoCurricular(infoFetch);
};
